"use client";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

function Pagination({ totalPages, currentPage, totalReviews, pageSize }) {
  // ssc mame searchParams dostupné jako paramater automaticky. V CC si musíme pomoci a načíst pomocí useSearchParams. Takže přečteme adresní řádek, který je pro nás jako state.
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const pageNumber = Number(searchParams.get("stranka")) || currentPage;
  const isOver = pageNumber >= totalPages;
  const isBegin = pageNumber <= 1;

  function handlePage(page) {
    const params = new URLSearchParams(searchParams);
    const newPage = pageNumber + page;

    params.set("stranka", newPage);
    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
  }

  const startReview = (pageNumber - 1) * pageSize + 1;
  const endReview = Math.min(pageNumber * pageSize, totalReviews);

  return (
    <div className="flex items-center justify-between gap-8">
      <button
        disabled={isBegin}
        onClick={() => handlePage(-1)}
        className="rounded-lg bg-blackBlue px-4 py-2 text-xl text-gold hover:underline hover:decoration-gold disabled:cursor-not-allowed disabled:opacity-20"
      >
        &lt; Novější
      </button>

      <div className="text-xl font-bold text-gold">
        {startReview === endReview
          ? startReview
          : `${startReview} .. ${endReview}`}{" "}
        / {totalReviews}
      </div>

      <button
        disabled={isOver}
        onClick={() => handlePage(+1)}
        className="rounded-lg bg-blackBlue px-4 py-2 text-xl text-gold hover:underline hover:decoration-gold disabled:cursor-not-allowed disabled:opacity-20"
      >
        Starší &gt;
      </button>
    </div>
  );
}

export default Pagination;
